import axios from "axios";
import Cookie from "js-cookie";

const URL = process.env.VUE_APP_API_BASE_URL;
console.log(process.env);
const request = axios.create({
  baseURL: URL,
  timeout: 600000,
});

request.interceptors.request.use((config) => {
  const token = Cookie.get("adfs-token");
  if (token) {
    config.headers["Authorization"] = "Bearer " + token;
  }
  return config;
});
request.interceptors.response.use(
  (res) => {
    console.log(res);
    const { status, messageKey } = res.data;
    if (status == 9999 && messageKey == "TOKEN_EXPIRED") {
      const r = confirm("身份信息已过期, 确认重新登录吗？");
      if (r) {
        Cookie.remove("adfs-token");
        window.location.reload();
      }
    }
    return res;
  },
  (err) => {
    console.log(err);
    const { response } = err;
    if (response.data) {
      const { status, messageKey } = response.data;
      if (status == 9999 && messageKey == "TOKEN_EXPIRED") {
        const r = confirm("身份信息已过期, 确认重新登录吗？");
        if (r) {
          Cookie.remove("adfs-token");
          window.location.reload();
        }
      }
    }
  }
);

export default request;
